export class Experiencia {
  idExperiencia: number;
  tituloProyecto: string;
  descripcion: string;
  empresa: string;
  fecha: string;
  imagen: string;
  tituloDetalle: string;
  descripcionDetalle: string;
  imagenDetalle: string;
  imagenDetalle2: string;
  imagenDetalle3: string;
  imagenDetalle4: string;
  porcentajePhotoshop: string;
  porcentajeIllustrator: string;
  porcentajeIndesign: string;
}
